import CloseIcon from "@mui/icons-material/Close";
import {
    Box,
    Chip,
    Container,
    Dialog,
    DialogContent,
    IconButton,
    Typography
} from "@mui/material";
import { useState } from "react";
import TransparentModel1 from '../assets/images/reviews/Feedback1.png';
import TransparentModel2 from '../assets/images/reviews/Feedback2.png';
import TransparentModel3 from '../assets/images/reviews/Feedback3.png';



const reviews = [
    TransparentModel1,
    TransparentModel2,
    TransparentModel3
];

const ReviewSection = ({ setShowForm, isSocialPage }) => {
    const [selectedImage, setSelectedImage] = useState(null);
    const handleJoinWhatsapp = () => {
        window.open(
            "https://chat.whatsapp.com/JInafRy5T98CYNpbqxXftR",
            "_blank",
            "noopener,noreferrer"
        );
    };

    return (
        <Box
            component="section"
            sx={{
                py: { xs: 6, md: 10 },
                background: isSocialPage === true ? '#fff' : `linear-gradient(
                    135deg,
                    hsl(38 92% 50% / .05) 0%,
                    hsl(0 0% 100%) 50%,
                    hsl(262 83% 58% / .05) 100%
                )`,
            }}
        >
            <Container maxWidth="lg">
                {/* Heading */}
                <Box textAlign="center" mb={6} >
                    {isSocialPage === true ? null : (<Chip label="Testimonials" color="primary"
                        sx={{
                            mb: 2,
                            fontWeight: 600,
                            bgcolor: '#fff',
                            color: '#00264d',
                            fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
                            border: '1px solid #00264d',
                            px: '1rem',
                            fontSize: '1.2rem',
                        }}
                    />)}

                    <Typography variant="h2"
                        sx={{
                            mb: 2,
                            fontWeight: 700,
                            fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
                            fontSize: '3.6rem',
                            lineHeight: '4rem',
                            color: isSocialPage === true ? '#0b4b91' : '#0f1a24'

                        }}
                    >
                        Trusted by Students Pan India
                    </Typography>

                    <Typography variant="inherit"
                        sx={{
                            maxWidth: "800px", mx: "auto",
                            fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
                            fontSize: '1.8rem',
                            lineHeight: '2.8rem',
                            color: '#52667a',
                            fontWeight: 400,
                        }}
                    >
                        Feedback from students and parents who trusted Medineer.AI in their admission journey.
                    </Typography>
                </Box>



                {/* Screenshot Grid */}
                <Box
                    sx={{
                        overflow: "hidden",
                        position: "relative",
                        py: 2,
                        mb: 4,

                        "&:before": {
                            content: '""',
                            position: "absolute",
                            left: 0,
                            top: 0,
                            width: "120px",
                            height: "100%",
                            zIndex: 2,
                            background:
                                "linear-gradient(to right, white, transparent)",
                        },

                        "&:after": {
                            content: '""',
                            position: "absolute",
                            right: 0,
                            top: 0,
                            width: "120px",
                            height: "100%",
                            zIndex: 2,
                            background:
                                "linear-gradient(to left, white, transparent)",
                        },
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            gap: 3,
                            width: "max-content",
                            animation: "reviewScroll 35s linear infinite",

                            "@keyframes reviewScroll": {
                                from: {
                                    transform: "translateX(0)",
                                },
                                to: {
                                    transform: "translateX(-50%)",
                                },
                            },

                            "&:hover": {
                                animationPlayState: "paused",
                            },
                        }}
                    >
                        {[...reviews, ...reviews].map((image, index) => (
                            <Box
                                key={index}
                                onClick={() => setSelectedImage(image)}
                                sx={{
                                    width: {
                                        xs: 240,
                                        sm: 260,
                                        md: 300,
                                    },
                                    flexShrink: 0,
                                    cursor: "pointer",
                                    borderRadius: 4,
                                    overflow: "hidden",
                                    bgcolor: "#fff",
                                    p: 3,
                                    boxShadow:
                                        "0 10px 30px rgba(0,0,0,0.08)",
                                    transition: ".3s",

                                    "&:hover": {
                                        transform: "translateY(-8px)",
                                        boxShadow:
                                            "0 20px 40px rgba(0,0,0,0.12)",
                                    },
                                }}
                            >
                                <Box
                                    component="img"
                                    src={image}
                                    alt={`review-${index}`}
                                    sx={{
                                        width: "100%",
                                        height: {
                                            xs: 420,
                                            md: 520,
                                        },
                                        objectFit: "cover",
                                        borderRadius: 3,
                                        display: "block",
                                    }}
                                />
                            </Box>
                        ))}
                    </Box>
                </Box>
                {/* <Grid container spacing={3}>
                    {reviews.map((image, index) => (
                        <Grid item xs={12} sm={6} md={4} key={index}>
                            <Box
                                onClick={() => setSelectedImage(image)}
                                sx={{
                                    cursor: "pointer",
                                    overflow: "hidden",
                                    borderRadius: 4,
                                    bgcolor: "#fff",
                                    p: 1,
                                    boxShadow:
                                        "0 10px 30px rgba(0,0,0,0.08)",
                                    transition: "all .3s ease",
                                    "&:hover": {
                                        transform: "translateY(-6px)",
                                        boxShadow:
                                            "0 20px 40px rgba(0,0,0,0.12)",
                                    },
                                }}
                            >
                                <Box
                                    component="img"
                                    src={image}
                                    alt={`review-${index + 1}`}
                                    sx={{
                                        width: "100%",
                                        height: 500,
                                        objectFit: "cover",
                                        borderRadius: 3,
                                        display: "block",
                                    }}
                                />
                            </Box>
                        </Grid>
                    ))}
                </Grid> */}
                {/* rating values cards  */}
                {/* <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        gap: 3,
                        flexWrap: "wrap",
                        mb: 3,
                    }}
                >
                    {[
                        { value: "4.9★", label: "Student Rating" },
                        { value: "1000+", label: "Students Subscribed" },
                        // { value: "100+", label: "Partner Institutes"     },
                    ].map((item) => (
                        <Box
                            key={item.label}
                            sx={{
                                minWidth: 180,
                                textAlign: "center",
                                p: 3,
                                bgcolor: "#fff",
                                borderRadius: 4,
                                boxShadow: "0 10px 30px rgba(0,0,0,.08)",
                            }}
                        >
                            <Typography
                                sx={{
                                    fontSize: "2rem",
                                    fontWeight: 700,
                                    background:
                                        "linear-gradient(135deg,#3b82f6,#8b5cf6)",
                                    WebkitBackgroundClip: "text",
                                    WebkitTextFillColor: "transparent",
                                }}
                            >
                                {item.value}
                            </Typography>

                            <Typography color="text.secondary"
                                sx={{
                                    fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
                                    fontSize: '1.8rem',
                                    lineHeight: '2.8rem',
                                    color: '#52667a',
                                    fontWeight: 400,
                                }}
                            >
                                {item.label}
                            </Typography>
                        </Box>
                    ))}
                </Box> */}

                {/* CTA */}
                {/* <Box textAlign="center" mt={6}>
                    <Button
                        startIcon={<WhatsAppIcon />}
                        variant="contained"
                        size="large"
                        onClick={handleJoinWhatsapp}
                        sx={{
                            borderRadius: 3,
                            textTransform: "none",
                            fontWeight: 600,
                            bgcolor: "#25D366",
                            "&:hover": {
                                bgcolor: "#1ebe5d",
                            },
                        }}
                    >
                        Join WhatsApp Community
                    </Button>
                </Box> */}

                {/* Image Preview */}
                <Dialog
                    open={Boolean(selectedImage)}
                    onClose={() => setSelectedImage(null)}
                    maxWidth="md"
                >
                    <DialogContent sx={{ p: 1, position: "relative" }}>
                        <IconButton
                            onClick={() => setSelectedImage(null)}
                            sx={{
                                position: "absolute",
                                top: 8,
                                right: 8,
                                bgcolor: "#fff",
                                zIndex: 1,
                            }}
                        >
                            <CloseIcon />
                        </IconButton>

                        {selectedImage && (
                            <Box
                                component="img"
                                src={selectedImage}
                                alt="review"
                                sx={{
                                    width: "100%",
                                    borderRadius: 2,
                                }}
                            />
                        )}
                    </DialogContent>
                </Dialog>
            </Container>
        </Box>
    );
};

export default ReviewSection;